/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GuaranteedRestoreTime {
    constructor(data) {
        this.actionDays = new Array(7).fill(false);
        if (data) {
            this.id = data.id;
            this.version = data.version;
            this.name = data.name;
            this.domainId = data.domainId;
            this.domainName = data.domainName;
            this.guaranteedRepairTime = data.guaranteedRepairTime;
            this.actionOpenTime = data.actionOpenTime;
            this.actionCloseTime = data.actionCloseTime;
            this.actionDays = this.actionDays.map(
                (isOpened, dayIndex) => data.actionDays.indexOf(dayIndex + 1) !== -1
            );
        } else {
            this.guaranteedRepairTime = 48;
            this.actionOpenTime = new Date();
            this.actionCloseTime = new Date();
            this.getSet24HoursADay(true);
            this.getSet7DaysAWeek(true);
        }
    }

    getSet24HoursADay(active24HoursADay) {
        if (active24HoursADay) {
            this.actionOpenTime.setTime(0);
            this.actionCloseTime.setTime(86340000);
        }
        return (this.actionOpenTime.getTime() === 0) && (this.actionCloseTime.getTime() === 86340000);
    }

    getSet7DaysAWeek(active7DaysAWeek) {
        if (active7DaysAWeek) {
            this.actionDays.fill(true);
        }
        return !this.actionDays.includes(false);
    }

    setActionOpenTime(actionOpenTime) {
        this.actionOpenTime.setTime(actionOpenTime.getTime());
        if (this.actionOpenTime.getTime() >= this.actionCloseTime.getTime()) {
            this.actionOpenTime.setHours(this.actionCloseTime.getHours());
            this.actionOpenTime.setMinutes(this.actionCloseTime.getMinutes() - 1);
        }
    }

    setActionCloseTime(actionCloseTime) {
        this.actionCloseTime.setTime(actionCloseTime.getTime());
        if (this.actionCloseTime.getTime() <= this.actionOpenTime.getTime()) {
            this.actionCloseTime.setHours(this.actionOpenTime.getHours());
            this.actionCloseTime.setMinutes(this.actionOpenTime.getMinutes() + 1);
        }
    }
}

export {GuaranteedRestoreTime};



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/GuaranteedRestoreTime.js